import React from 'react';
import bindAll from 'lodash.bindall';

import CodeEditorComponent from '../components/code-editor/code-editor.jsx';

// eslint-disable-next-line react/prefer-stateless-function
class CodeEditor extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleSize',
            'containerRef'
        ]);
        this.state = {
            clientHeight: null,
            clientWidth: null
        };
    }

    componentDidMount () {
        window.addEventListener('resize', this.handleSize);
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.handleSize);
    }

    handleSize () {
        const rect = this.containerElement.getBoundingClientRect();
        this.setState({
            clientHeight: rect.height,
            clientWidth: rect.width
        });
    }

    containerRef (el) {
        if (el) {
            this.containerElement = el;
            const rect = this.containerElement.getBoundingClientRect();
            this.setState({
                clientHeight: rect.height,
                clientWidth: rect.width
            });
        }
    }

    render () {
        const {
            ...props
        } = this.props;
        return (
            <CodeEditorComponent
                height={this.state.clientHeight || '100%'}
                width={this.state.clientWidth || '100%'}
                containerRef={this.containerRef}
                {...props}
            />
        );
    }
}

export default CodeEditor;
